const hasItems = value => Array.isArray(value) && value.length > 0

const hasScipInformation = value => !!(
    value
    && typeof value.scipNumber === 'string'
    && value.scipNumber.trim()
)

const createDocumentComplianceCompositionContext = ({
    draft = {},
    item = {},
    reviewContext = {},
} = {}) => {
    const classification = draft.classification || {}
    const documentInformation = draft.documentInformation || {}
    const substanceAssessment = draft.substanceAssessment || {}
    const productLookup = reviewContext.productLookup || {}

    return Object.freeze({
        document: Object.freeze({
            scope: classification.scope || null,
            type: documentInformation.type || null,
            relevance: documentInformation.relevance || null,
            hasLegislations: hasItems(draft.legislations),
            hasScipInformation: hasScipInformation(draft.scipInformation),
            hasSubstances: hasItems(substanceAssessment.substances),
            hasProducts: hasItems(draft.products),
        }),
        review: Object.freeze({
            itemStatus: item.status || null,
            productLookupAvailable: productLookup.available === true,
        }),
    })
}

export { createDocumentComplianceCompositionContext }
